import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta, useAuth } from "hooks";
import { useCreateVendorStaffMutation } from "store/services/vendorStaffApi";
import VendorStaffForm from "./VendorStaffForm";

const VendorStaffCreateScreen = () => {
    const { viewEntity } = useAuth();
  const navigate = useNavigate();
    const { loggedInUser } = useAuth();

  const breadcrumbs = [

    { title: "Staffs", path: "/app/vendor/staffs/list" },
    { title: "New Staff" },
  ];

  // RTK Query
  const [createStaff, { isLoading: creatingStaff }] = useCreateVendorStaffMutation();

  // methods
  const handleAddStaff = async (data) => {
    try {
      const formattedData = {
        ...data,
        connectedVendor: loggedInUser?.typeRef,
        entity: viewEntity?._id,
      };
  
     const vendorStaff=  await createStaff(formattedData).unwrap();
      toast.success("Staff successfully created!");
      navigate(`../${vendorStaff?._id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't add staff!");
    }
  };

  useAppMeta("New Staff");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingStaff}>
      <BreadcrumbLayout.Paper>
        <VendorStaffForm isBusy={creatingStaff} onSubmit={handleAddStaff} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorStaffCreateScreen;
